"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDemoLicense = exports.isSoftLock = exports.isMindProductType = exports.needsActivation = void 0;
const string_1 = require("../../common/js/helper/string");
const LicenseActivationProductTypes_1 = __importDefault(require("../constants/LicenseActivationProductTypes"));
const LockType_1 = __importDefault(require("../enums/LockType"));
const ProductType_1 = __importDefault(require("../enums/ProductType"));
const needsActivation = (license) => {
    if (license.activated) {
        return false;
    }
    if (!!license.activationUrl) {
        return true;
    }
    const type = license.productType;
    if (!type) {
        return false;
    }
    return Array.from(LicenseActivationProductTypes_1.default).includes((0, string_1.slugifyKey)(type));
};
exports.needsActivation = needsActivation;
const isMindProductType = (type) => {
    const mindProductTypes = [ProductType_1.default.MINDCUT, ProductType_1.default.MINDGEST, ProductType_1.default.MINDGUEST];
    return mindProductTypes.includes(type);
};
exports.isMindProductType = isMindProductType;
const isSoftLock = (lockType) => {
    if (!lockType) {
        return false;
    }
    return lockType === LockType_1.default.SOFTLOCK;
};
exports.isSoftLock = isSoftLock;
const isDemoLicense = (license) => /demo/gi.test(license.name ?? '');
exports.isDemoLicense = isDemoLicense;
